<template>
  <div class="result">
    <ContentsBoxGold>
      <h1 class="title">
        <div class="text">
          <img
            :src="require(`@images/result/${locale}/title.png`)"
            :alt="$t('text001', null, 'localeResult')"
          >
        </div>
      </h1>
      <p class="emphasis-block" v-html="$t('text002', null, 'localeResult')" />
      <ol class="character-wrap">
        <li v-for="(item,i) in restOfHeroes" :key="i" class="character" :class="[`-rank${item.rank}`]">
          <img class="image" :src="require(`@images/result/character/${item.heroId}.png`)">
          <div class="detail">
            <div class="inner">
              <div class="another-name" v-html="heroName(item.heroId).nickname" />
              <div class="name" v-html="heroName(item.heroId).name" />
              <div class="votes-count">{{ localeFigure(item.voteCount) }}{{ $t('text003', null, 'localeResult') }}</div>
            </div>
          </div>
        </li>
      </ol>
      <ContentsBoxGoldButton v-if="termType === 4" button-color="button-blue" @click="goToVotingGauntlet()">
        <img
          :src="require(`@images/result/${locale}/text_voting-match.png`)"
          :alt="$t('text012', null, 'localeResult')"
        >
      </ContentsBoxGoldButton>
    </ContentsBoxGold>

    <ResultNav />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import store from '@/store/index'

import { ranking } from '@constants/ranking'

import ContentsBoxGold from '@components/contents-box-gold/index.vue'
import ContentsBoxGoldButton from '@components/contents-box-gold/button.vue'
import ResultNav from '@components/result/nav.vue'

import localeResult from '@locales/result'
import localeCharacter from '@locales/character'

export default {
  name: 'result',
  beforeRouteEnter (to, from, next) {
    if (store.getters['currentState/termType'] >= 3) {
      next()
    } else {
      next('/')
    }
  },
  $messages: { localeResult, localeCharacter },
  components: {
    ContentsBoxGold,
    ContentsBoxGoldButton,
    ResultNav,
  },
  computed: {
    ...mapGetters('currentState', ['termType']),
    locale() {
      return this.$route.params.lang ? this.$route.params.lang : 'ja-JP'
    },
    rankdata() {
      return ranking.filter(r => Number(r.rank) <= 8)
    },
    restOfHeroes() {
      if(!this.rankdata) return
      return this.rankdata.filter(r => Number(r.rank) > 0 ).sort((a,b) => {
        if (a.rank > b.rank) {
          return 1;
        } else {
          return -1;
        }
      })
    }
  },
  methods: {
    goToVotingGauntlet(){
      window.open('https://support.fire-emblem-heroes.com/voting_gauntlet/howtoplay', '_blank')
    },
    heroName(heroId) {
      return this.$t(heroId, null, 'localeCharacter')
    },
    localeFigure(count) {
      const locale = this.$route.params.lang
      const num = String(count)
      if (locale === 'de-DE' || locale === 'es-ES' || locale === 'es-MX' || locale === 'fr-CA' || locale === 'fr-FR') {
        return num.replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1 ')
      } else if (locale === 'it-IT' || locale === 'it-IT' || locale === 'pt-BR') {
        return num.replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')
      } else {
        return num.replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.result {
  margin-bottom: 34px;
}

.contents-box {
  margin-top: 177px;
  background-position: center 270px, center 0;
  > .title {
    width: 628px;
    height: 207px;
    margin-top: -220px;
    position: relative;
    background: url(#{$img-path}result/bg_title.png) no-repeat 0 0;
    .text {
      height: 75px;
      width: 100%;
      position: absolute;
      top: 117px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .emphasis-block {
    position: relative;
    margin-top: 17px;
    padding: 40px 75px;
  }
}
.character {
  position: relative;
  box-sizing: border-box;
  height: 552px;
  width: 261px;
  &::before {
    position: absolute;
    content: "";
    display: block;
    top: 0;
    left: 24px;
    width: 62px;
    height: 63px;
    z-index: 20;
  }
  .image {
    position: absolute;
    top: 0;
    left: 0;
    transform: translateX(-50%);
    left: 50%;
    height: 100%;
    object-fit: cover;
  }
  .detail {
    position: absolute;
    margin: 0 auto;
    height: 104px;
    box-sizing: border-box;
    border-style: solid;
    border-width: 46px 36px 43px 35px;
    border-image: url(#{$img-path}result/bg_character-detail.png) 46 36 43 35 fill stretch;
    line-height: 1.2;
    width: 222px;
    bottom: 35px;
    transform: translateX(-50%);
    left: 50%;
    .inner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateY(-50%) translateX(-50%);
    }
    .another-name,
    .name,
    .votes-count {
      width: 200px;
      text-align: center;
    }
    .another-name {
      font-size: $fs-middle;
    }
  }
  &.-rank1::before {
    background-image: url(#{$img-path}icon/ico_rank1.png);
  }
  &.-rank2::before {
    background-image: url(#{$img-path}icon/ico_rank2.png);
  }
  &.-rank3::before {
    background-image: url(#{$img-path}icon/ico_rank3.png);
  }
  &.-rank4::before {
    background-image: url(#{$img-path}icon/ico_rank4.png);
  }
  &.-rank5::before {
    background-image: url(#{$img-path}icon/ico_rank5.png);
  }
  &.-rank6::before {
    background-image: url(#{$img-path}icon/ico_rank6.png);
  }
  &.-rank7::before {
    background-image: url(#{$img-path}icon/ico_rank7.png);
  }
  &.-rank8::before {
    background-image: url(#{$img-path}icon/ico_rank8.png);
  }
}
.character-wrap {
  display: flex;
  flex-wrap: wrap;
  width: 522px;
  margin: 60px auto 20px;
  list-style: none;
  padding: 0;
}
.button-decoration {
  margin-bottom: -27px;
  z-index: 10;
}
</style>
